<template>
	<v-layout row wrap justify-center pt-10>
		<v-layout justify-center>
			<v-flex xs12 sm6>
				<v-card
					style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;"
				>
					<v-toolbar flat>
						Tabela de Crescimento Animal
					</v-toolbar>
					<v-data-table
						:headers="headers"
						no-results-text="Nenhum registro encontrado"
						:items="values"
						color="secondary"
						loading-text="Carregando registros...aguarde"
					>
					</v-data-table>
				</v-card>
			</v-flex>
		</v-layout>
	</v-layout>
</template>

<script>
export default {
	name: "TabelaCrescimentoAnimal",
	data() {
		return {
			headers: [
				{ text: "Semana", value: "nrSemana", sortable: false },
				{ text: "Idade (dias)", value: "nrDias", sortable: false },
				{ text: "Peso", value: "qtPeso", sortable: false }
			]
		};
	},
	computed: {
		values() {
			return this.$store.state.tabelaCrescimentoAnimal[
				this.$store.state.token.PARTNERID
			];
		}
	}
};
</script>

<style scoped>
</style>
